export const HUMIDITY_SOURCE:string[] = [
  'ocean'
]
